module.exports = __webpack_public_path__ + "assets/img/page-title-9b0ad51e.png";